import { render, staticRenderFns } from "./OutOfHour.vue?vue&type=template&id=963d60b0&"
import script from "./OutOfHour.vue?vue&type=script&lang=js&"
export * from "./OutOfHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports